'use strict';

(function () {
    const FF_TABLE_BREAK_VERSION = 57;
    const oldFF = $.browser.mozilla && $.browser.versionNumber < FF_TABLE_BREAK_VERSION;
    $(document.documentElement).toggleClass('ff-before-57', oldFF).toggleClass('ff-since-57', !oldFF);
})();
